import { FC, ReactElement } from 'react';
import styles from './styles.module.css';
import CheckBox from '../../../../components/common/CheckBox';

type Variant = 'contain';
export type ValueObj = {
  name?: string;
  label: string;
  value: string;
  checked: boolean;
};
export type CheckBoxGroupOnChangeProps = {
  values: ValueObj[];
  selectedValues: string[];
};
type Props = {
  values: ValueObj[];
  inputs?: (
    values: ValueObj[],
    onSelect: (selected: ValueObj) => void
  ) => ReactElement;
  onChange: (newValues: CheckBoxGroupOnChangeProps) => void;
  placeholder?: string;
  variants?: Variant[];
};

const CheckBoxs: FC<Props> = ({ values, onChange }) => {
  const selectNotAll = () => {
    const newValues = values.map((v) => ({ ...v, checked: false }));
    const selectedValues = newValues
      .filter((v) => v.checked)
      .map((v) => v.value);
    onChange({ values: newValues, selectedValues });
  };
  const onSelect = (selected: ValueObj) => {
    const newValues = values.map((v) => {
      if (v.value !== selected.value) {
        return v;
      }
      return {
        ...v,
        checked: !selected.checked,
      };
    });
    const selectedValues = newValues
      .filter((v) => v.checked)
      .map((v) => v.value);
    onChange({ values: newValues, selectedValues });
  };

  const lineDOM = (v: ValueObj) => (
    <div className={styles.item} key={v.value}>
      <CheckBox
        value={v.value}
        checked={v.checked}
        onChange={() => onSelect(v)}
        name={v.name}
        label={v.label}
      />
    </div>
  );

  return (
    <>
      <div className={styles.item}>
        <CheckBox
          checked={values.every((v) => !v.checked)}
          onChange={selectNotAll}
          label="なし"
        />
      </div>
      <div className={styles.popup}>
        <div className={styles.line}>{values.map(lineDOM)}</div>
      </div>
    </>
  );
};

export default CheckBoxs;
